import { useMemo } from 'react';
import moment from 'moment/moment';

import {
  formatHourEntryTimes,
  formatSecondsToDuration,
} from '@timekeeping/services';
import {
  HourEntryFragment,
  ReviewHourBlockFragment,
} from '@common/graphql/schema';

export type TableHourBlock = {
  id: string;
  date: moment.Moment;
  inOutEntry: HourEntryFragment;
  inOut: string;
  lunchBreakEntry: HourEntryFragment | null;
  lunchBreak: string;
  hourType: string;
  costCenter: string | null | undefined;
  billingRate: number | null | undefined;
  unitAndLocation: [string, string];
  totalTime: string;
  totalOvertime: string;
  totalHoliday: string;
  notes: string;
  state: string;
  workerTimesheet: {
    id: string;
    canManagerUpsertHours: {
      value: boolean;
    };
    staffingRequestAssignments?: { id: string }[];
  };
};

export const useHourBlocksForTable = (
  hourBlocks: ReviewHourBlockFragment[] | undefined | null
) =>
  useMemo(() => {
    return (hourBlocks || []).map((block): TableHourBlock => {
      const times = block.classifiedTimes;
      const lunch =
        !block.skippedLunchBreak && block.lunchBreak ? block.lunchBreak : null;

      return {
        id: block.id,
        date: moment(block.shiftDate),
        hourType: block.hourType!.name,
        costCenter: block.unit!.costCenter,
        billingRate: block.billingRate,
        unitAndLocation: [block.unit!.name, block.facility!.name],
        inOutEntry: block.inOut,
        inOut: formatHourEntryTimes(block.inOut),
        lunchBreakEntry: lunch,
        lunchBreak: lunch ? formatHourEntryTimes(lunch) : '',
        totalTime: formatSecondsToDuration(block.totalSeconds),
        totalOvertime: formatSecondsToDuration(times.overtimeSeconds),
        totalHoliday: formatSecondsToDuration(times.holidaySeconds),
        notes: block.notes || '',
        state: block.state,
        workerTimesheet: block.workerTimesheet,
      };
    });
  }, [hourBlocks]);
